/**
 * Observer: ao sair do campo CEP (blur), consulta ViaCEP (base dos Correios)
 * e preenche logradouro, bairro, UF e município. O município é resolvido
 * via IndexedDB ou API quando não houver cache local.
 */
import db from '../../versa/db.js';
import api from '../api.js';
import { loadOptions } from '../../versa/formset.js';
import { notify } from '../../versa/msgbox.js';

const VIACEP_URL = 'https://viacep.com.br/ws';

export default function () {
	return {
		events: ['blur'],
		async handleEvents(ev) {
			if (ev.type !== 'blur') return;
			const node = document.querySelector(this.selector);
			if (!node?.form) return;
			const cep = (node.value || '').replace(/\D/g, '');
			if (cep.length !== 8) return;

			const m = this.selector?.match(/#(\w+)_zipcode$/);
			const pre = m ? m[1] : 'address';
			const streetEl = node.form.querySelector(`#${pre}_street`);
			const districtEl = node.form.querySelector(`#${pre}_district`);
			const stateEl = node.form.querySelector(`#${pre}_state`);
			const cityEl = node.form.querySelector(`#${pre}_city_id`);

			try {
				const res = await fetch(`${VIACEP_URL}/${cep}/json/`);
				const data = await res.json();
				if (data?.erro) {
					notify('CEP não encontrado na base dos Correios.', 'Consulta CEP');
					return;
				}
				if (streetEl) streetEl.value = data.logradouro || '';
				if (districtEl) districtEl.value = data.bairro || '';
				if (stateEl) {
					stateEl.value = data.uf || '';
					stateEl.dispatchEvent(new Event('change', { bubbles: true }));
				}
				if (cityEl && data.localidade && data.uf) {
					await _resolveAndSetCity(this.form, cityEl, data.localidade, data.uf, pre);
				}
			} catch (_) {}
		}
	};
}

async function _resolveAndSetCity(form, cityEl, cityName, uf, prefix) {
	if (!form || !cityEl) return;
	const u = String(uf || '').trim().toUpperCase().slice(0, 2);
	const norm = s => String(s || '').toLowerCase().trim();
	const target = norm(cityName);
	let cities = await db.list('cities', IDBKeyRange.bound([u, ''], [u, '\uffff']), 2).catch(() => []);
	if (!cities?.length && u.length >= 2) {
		const data = await api.call(api.list_cities, `?filter=state*eq*${encodeURIComponent(u)}&limit=500`);
		cities = Array.isArray(data) ? data : [];
	}
	const city = (cities || []).find(c => norm(c?.city) === target);
	if (city) {
		loadOptions(`#${prefix}_city_id`, cities, 'id', ['city']);
		const cityField = form.getFieldBySelector?.(`#${prefix}_city_id`);
		if (cityField) {
			cityField.setValue(city.city);
			cityField.refresh?.();
		} else if (cityEl) {
			cityEl.value = city.city;
		}
	} else if (cityName) {
		cityEl.value = cityName;
	}
}
